import React, { useState } from "react";
// import { InputAdornment, IconButton } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
// import MDInput from "components/MDInput";
import AddUserDetailsPopup from "./AddUserDetailsPopup";
// import { setSearchGroup } from "features/management/userManagement/userSlice";
// import { useDispatch } from "react-redux";

function FilterCard() {
  // const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  return (
    <>
      <MDBox borderRadius="12px" width="100%" boxShadow="sm">
        <MDBox
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gap={2}
        >
          {/* Search input */}
          {/* <MDInput
            placeholder="Search user..."
            size="small"
            sx={{ width: "250px" }}
            onChange={(e) => dispatch(setSearchGroup(e.target.value))}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" size="small">
                    <SearchIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          /> */}

          <MDButton
            variant="gradient"
            color="warning"
            sx={{
              textTransform: "none",
              fontWeight: "medium",
              borderRadius: "10px",
            }}
            onClick={() => setOpen(true)}
          >
            + New User
          </MDButton>
        </MDBox>
      </MDBox>

      <AddUserDetailsPopup open={open} onClose={() => setOpen(false)} />
    </>
  );
}

export default FilterCard;
